import { onMounted, onBeforeUnmount } from 'vue';
import { useNuxtApp } from 'nuxt/app';
import { FLUSH_VIEW_BANNER, FLUSH_VIEW_PRODUCT_LIST } from '~~/common/plugins/aw-analytics';

export function useAnalyticsQueue () {
  let flushInterval: ReturnType<typeof setInterval> | undefined = undefined;
  onMounted(() => {
    const {
      $awAnalytics,
      $awMergedConfig: {
        viewPromotionAnalyticsIntervalLength,
      },
    } = useNuxtApp();
    if (!viewPromotionAnalyticsIntervalLength) {
      return;
    }
    flushInterval = setInterval(() => {
      $awAnalytics[FLUSH_VIEW_BANNER]({ isHistoryFlushed: false });
      $awAnalytics[FLUSH_VIEW_PRODUCT_LIST]();
    }, viewPromotionAnalyticsIntervalLength);
  });
  onBeforeUnmount(() => {
    clearInterval(flushInterval);
  });
}
